import React from 'react';
import { Box, Container, Icon } from '@drivekyte/web-components';
import styled from 'styled-components';
import Logo from '../../../logo';
import NavLinks from '../../../nav-links';

type NavigationExpandedProps = {
  onPress: () => void;
  isSubscription: boolean;
};

const NavigationExpanded = ({
  onPress,
  isSubscription,
}: NavigationExpandedProps) => (
  <Box
    backgroundColor="primary"
    bottom="0px"
    height="100%"
    left="0px"
    position="fixed"
    right="0px"
    top="0px"
    width="100%"
    zIndex={5}
  >
    <Container>
      <Box
        alignItems="center"
        display="flex"
        justifyContent="space-between"
        paddingVertical="xSmall"
      >
        <Logo />
        <Box
          boxSizing="border-box"
          cursor="pointer"
          onPress={onPress}
          padding="xTiny"
        >
          <Icon name="24-close-big" />
        </Box>
      </Box>
      <NavLinksContainer>
        <NavLinks isSubscription={isSubscription} collapseNav={onPress} />
      </NavLinksContainer>
    </Container>
  </Box>
);

const NavLinksContainer = styled.div`
  > a {
    display: block;
    margin-bottom: ${({ theme }) => theme.spacings.medium}px;
  }
`;

export default NavigationExpanded;
